import { connect } from 'react-redux';
import { getFetchError, getIsLoading, getIsOnline } from 'store/reducers/content';
import { getIsLoggedIn, getIsGigyaLoading } from 'store/reducers/user';
import { State } from 'redux';

import MyJukePage from './MyJukePage';

const mapStateToProps = (state: State) => ({
  isUserLoggedIn: getIsLoggedIn(state),
  isLoading: getIsLoading(state) || getIsGigyaLoading(state),
  error: getFetchError(state),
  isOnline: getIsOnline(state),
});

export default connect(mapStateToProps)(MyJukePage);
